import { Box, Button, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { WelcomeProps } from '../../interfaces/components';
import WelcomeDesktopImage from '../../assets/images/WelcomeDesktop.jpg';

interface WelcomeDesktopProps extends WelcomeProps {
  subTitle: string;
  title: string;
  description: string;
  onClose: () => void;
}

const WelcomeDesktop = ({ activeLocale, active, subTitle, title, description, onClose }: WelcomeDesktopProps) => {
  return (
    <Box
      zIndex="10"
      opacity={active ? 1 : 0}
      visibility={active ? 'visible' : 'hidden'}
      transition="all 0.5s"
      position="fixed"
      top={0}
      right={0}
      left={0}
      bottom={0}
      margin="auto"
      bg="white"
      width="100%"
      height="100%"
      onClick={onClose}
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
    >
      <Image
        position="absolute"
        top={0}
        left={0}
        zIndex={1}
        height="100vh"
        w="100%"
        src={WelcomeDesktopImage}
        objectFit="cover"
      />

      <Box padding={['20px', '20px', '0px', '0px', '0px']}>
        <Box
          height={['350px', '400px', '450px', '500px', '550px']}
          backgroundColor={'white'}
          position={'relative'}
          zIndex={2}
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          pointerEvents={active ? 'all' : 'none'}
          padding={['20px', '20px', '22px', '24px', '24px']}
        >
          <Box
            width={['100%', '100%', '100%', '100%', '100%']}
            height={['100%', '100%', '100%', '100%', '100%']}
            display="flex"
            justifyContent={'center'}
            alignItems={'center'}
            flexDirection={'column'}
            outline={'4px solid #FFCB00'}
          >
            <Box
              width={'80%'}
              display="flex"
              justifyContent={'center'}
              alignItems={'center'}
              flexDirection={'column'}
              gap={'10px'}
            >
              <Text
                fontSize={['18px', '18px', '18px', '24px', '24px']}
                fontFamily={activeLocale === 'ar' ? 'GETwoMedium' : 'LoccitaneRegular'}
                textAlign="center"
                textTransform={'capitalize'}
              >
                {subTitle}
              </Text>
              <Text
                fontSize={['35px', '35px', '50px', '50px', '50px']}
                fontFamily={activeLocale === 'ar' ? 'GETwoBold' : 'LoccitaneBoldItalic'}
                textAlign="center"
                textTransform={'capitalize'}
              >
                {title}
              </Text>
              <Text
                fontSize={['14px', '14px', '18px', '18px', '18px']}
                fontFamily={activeLocale === 'ar' ? 'GETwoMedium' : 'RalewayRegular'}
                fontWeight="500"
                textAlign="center"
              >
                {description}
              </Text>
              <Button
                variant="outline"
                borderColor="#FFCB00"
                color="black"
                borderRadius="0px"
                h={['30px', '40px', '50px', '50px', '50px']}
                w={['150px', '200px', '230px', '270px', '270px']}
                bg="#FFCB00"
                fontSize={['12px', '14px', '14px', '16px', '16px']}
                _hover={{ bg: 'white' }}
                _active={{ bg: 'white' }}
                _focus={{ bg: '#FFCB00' }}
                cursor="pointer"
                pointerEvents="auto"
                fontFamily={'RalewaySemiBold'}
                marginTop={['10px', '20px', '20px', '20px', '20px']}
              >
                Enter
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default WelcomeDesktop;
